import type { ApiRoute, NoPathParams, NoResponse } from "../../api"

export interface SetSelectedInteriorQueryParams {
	"inventory-id": string
}

export interface SelectedInteriorChange {
	optionCode: string
}

export const setSelectedInteriorRoute: ApiRoute<
	NoPathParams,
	SetSelectedInteriorQueryParams,
	SelectedInteriorChange,
	NoResponse
> = {
	buildUrl: () => "/colors/interior/selected",
	method: "post",
	path: "/colors/interior/selected",
}
